export enum BrokerageNoteTypeEnum {
  LAST_NOTE = 0,
  SPECIFIC_DATE = 1,
  MY_NOTE = 2
}
